import SelectControl from './select-control';

export default SelectControl;